import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { DropDown } from 'src/app/interfaces/drop-down.interface';
import { OrganizationService } from 'src/app/services/organization.service';
import { DropDownTreeComponent } from '@syncfusion/ej2-angular-dropdowns';
import {  MultiDropDown } from 'src/app/interfaces/drop-down.interface';

interface TreeNode {
  id: string;
  pid: string | null;
  text: string;
  hasChildren?: boolean;
  expanded?: boolean;
  selectable?: boolean;
  value?: string;
  child?: TreeNode[];
}

export const ORGANIZATION_FORM_CONTROL_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiSelectOrganizationFormFieldComponent),
  multi: true,
};

@Component({
  selector: 'app-multi-select-organization-form-field',
  providers: [ORGANIZATION_FORM_CONTROL_ACCESSOR],
  templateUrl: './multi-select-organization-form-field.component.html',
  styleUrls: ['./multi-select-organization-form-field.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiSelectOrganizationFormFieldComponent
  implements ControlValueAccessor, OnChanges, AfterViewInit
{
//  @ViewChild('organizationField') organizationField: MultiSelectComponent;
  @ViewChild('organizationDropDownTree') dropDownTree: DropDownTreeComponent;
  @ViewChild('organizationTreeWrapper', { read: ElementRef }) locationTreeElementRef: ElementRef;

  @Input() orgId: number = null;
  @Input() includeChildOrgs: boolean = null;
  @Input() disabledOrgIds: number[] = [];

  options: DropDown<string>[] = [];
  //fields: Object = { value: 'value', text: 'text' , disabled: 'disabled'};
  loading: boolean = false;
  _value: DropDown<string>[] = [];

  public treeData:TreeNode[] = [];
  private dataLoaded = false;

  get treeFields(): any {
    return {
      dataSource: this.treeData,
      id: 'id',
      parentValue: 'pid',
      text: 'text',
      hasChildren: 'hasChildren',
      value: 'value'
    };
  }
getEnabledSelectedCount(): number {
  return this.selectedOrganizationIds.filter(id => !this.isReadonly(id)).length;
}

  public watermark: string = 'Select a Organization';
  public showCheckBox = true;
  public mode = "Custom";
  public treeSettings: Object = {  autoCheck: false,
  loadOnDemand: false };
  public filterType: string = 'Contains';
  public organizationNodeIds: string[] = [];
  public selectedOrganizationIds: string[] = [];


  constructor(
    private _os: OrganizationService,
    private _cdr: ChangeDetectorRef,
  ) {}

  private _disabled: boolean = false;
  public get disabled(): boolean {
    return this._disabled || this.loading;
  }
  public set disabled(value: boolean) {
    this._disabled = value;
  }

  

  ngAfterViewInit(): void {
    this.updateOrganizationField();
  }

  private updateOrganizationField() {
    if (this.dropDownTree) {
      this.dropDownTree.value = [...this.selectedOrganizationIds];
      this.dropDownTree.dataBind();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orgId']) {
      this.selectedOrganizationIds = [];
      this.treeData = [];
      this.organizationNodeIds = [];
       this.loadOrganizationData();
    }
  }

  private loadOrganizationData(): void {
    this.loading = true;
    this._cdr.markForCheck();

    this._os.getOrganizationsForDropDownByParentOrgId(this.orgId).subscribe((orgs) => {
    this.treeData = this.buildFlatTree(orgs);
    this.dataLoaded = true;
    this.organizationNodeIds = this.getAllOrganizationNodeIds(this.treeData);
    this.selectedOrganizationIds = [];
    this.loading = false;

    setTimeout(() => {
      this.updateOrganizationField();
      //this.updateDisplayText();
      if (this.dropDownTree) {
        this.dropDownTree.dataBind();
      }
      this.onDataBound();
      this._cdr.detectChanges();
    });
  });
}

private getAllOrganizationNodeIds(data: any[]): string[] {
  return data
    .filter(node => node.selectable && node.id.startsWith('org_'))
    .map(node => node.id);
}

// private updateDisplayText(): void {
//   setTimeout(() => {
//     const input: HTMLInputElement =
//       this.locationTreeElementRef?.nativeElement.querySelector('input');

//     if (input) {
//       const organizationCount = this.selectedOrganizationIds.filter(id => id.startsWith('org_')).length;
//       input.value =
//         organizationCount > 0 ? `${organizationCount} Organization${organizationCount > 1 ? 's' : ''} Selected` : '';
//     }
//   }, 0);
// }

private buildFlatTree(data: any[]): TreeNode[] {
  const flat: TreeNode[] = [];

  data.forEach((item) => {
    const orgId = `org_${item.orgId}`;

    flat.push({
      id: orgId,
      pid: null,
      text: item.orgName,
      hasChildren: false,
      selectable: true, // still needed so node renders
      value: orgId
    });
  });

  return flat;
}


onDataBound(): void {
  setTimeout(() => {
    const treeViewObj = (this.dropDownTree as any).treeObj;
    if (!treeViewObj || !this.treeData?.length) return;

    const disabledSet = new Set<string>();

    // Step 1: Disable all tank nodes based on disabledLocationIds
    const disabledOrganizationNodeIds = this.treeData
      .filter(node =>
        node.id.startsWith('org_') &&
        this.disabledOrgIds.includes(Number(node.id.replace('org_', '')))
      )
      .map(node => node.id);

    // Add to disabled set
    disabledOrganizationNodeIds.forEach(id => disabledSet.add(id));

    // // Step 2: Disable organizations if all their child locations are disabled
    // const orgNodes = this.treeData.filter(node => node.id.startsWith('org_'));
    // for (const org of orgNodes) {
    //   const childLocs = this.treeData.filter(n => n.pid === org.id && n.id.startsWith('loc_'));
    //   if (childLocs.length && childLocs.every(child => disabledSet.has(child.id))) {
    //     disabledSet.add(org.id);
    //   }
    // }

    // ✅ Step 3: Build final checked set
    const selectedIdsFromWriteValue = (this._value ?? []).map(v => `org_${v.value}`);
    const allValidIds = new Set(this.treeData.map(n => n.id));
    const manuallyIncludeDisabledIds = disabledOrganizationNodeIds.filter(id => allValidIds.has(id));

    const finalCheckSet = new Set<string>([
      ...this.selectedOrganizationIds,
      ...selectedIdsFromWriteValue,
      ...manuallyIncludeDisabledIds,
    ]);

    // Only keep valid node IDs from the tree
    const validCheckedNodes = [...finalCheckSet].filter(id =>
      this.treeData.some(node => node.id === id)
    );

    // Step 4: Apply checked nodes
    treeViewObj.checkedNodes = validCheckedNodes;
    treeViewObj.dataBind();


    // Step 4: Apply all disabled node IDs
    if (treeViewObj.disableNodes) {
      treeViewObj.disableNodes(Array.from(disabledSet));
    }

    this.selectedOrganizationIds = validCheckedNodes.filter(id =>
      id.startsWith('org_') &&
      !this.disabledOrgIds.includes(Number(id.replace('org_', '')))
    );
    this._cdr.detectChanges();
  });
}

  onOrganizationTreeChange(event: any): void {
    const selectedIds = event.value || [];

    const treeViewObj = (this.dropDownTree as any).treeObj;
    const checkedNodeIds = new Set(treeViewObj?.getAllCheckedNodes?.() ?? []);

    // Sync back the checked nodes
    treeViewObj.checkedNodes = Array.from(checkedNodeIds);
    treeViewObj.dataBind();

    // Filter out disabled tank node IDs
    const enabledOrgIds = selectedIds.filter((id: string) => {
      const isOrg = id.startsWith('org_');
      if (!isOrg) return true; // allow org/loc if needed for UI, but won't be returned
      const orgIdNum = Number(id.replace('org_', ''));
      return !this.disabledOrgIds.includes(orgIdNum);
    });

    this.selectedOrganizationIds = enabledOrgIds.filter((id: string) =>
      this.organizationNodeIds.includes(id)
    );
    this._cdr.detectChanges();
    const selectedValues: DropDown<string>[] = this.getSelectedDropDownsFromIds(this.selectedOrganizationIds);

    this.onTouched();
    this.onChange(selectedValues);

    //setTimeout(() => this.updateDisplayText(), 0);
  }

  private getSelectedDropDownsFromIds(ids: string[]): DropDown<string>[] {
    const results: DropDown<string>[] = [];

    const flatten = (nodes: any[]) => {
      for (const node of nodes) {
        if (node.selectable && ids.includes(node.id)) {
          results.push({ text: node.text, value: node.id.replace('org_', '') });
        }
        if (node.child) {
          flatten(node.child);
        }
      }
    };

    flatten(this.treeData);
    return results;
  }
  
  // Function to call when the input changes.
  onChange = (value: DropDown<string>[]| null) => {};

  // Function to call when the input is touched.
  onTouched = () => {};

  // Allows Angular to update the model (organizationControl).
  // Update the model and changes needed for the view here.
  writeValue(value: MultiDropDown<string>[]): void {
    if (value) {
            this.selectedOrganizationIds = value.map(v => `org_${v.value}`);
      } else {
        this.selectedOrganizationIds = [];
      }

      if (this.treeData?.length) {
        this.updateOrganizationField();
      }
      // if (value !== null) {
      //   this.onChange(value);
      // }
}


  // Allows Angular to register a function to call when the model (organizationControl) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this._cdr.markForCheck();
  }

    onFiltering(event: any): void {
  // Optional: can customize filtering behavior if needed
  // For now, allow default filtering
}

onInput(event: any): void {
  const inputValue = event?.target?.value?.trim() ?? '';

  if (!inputValue) {
    // Filter cleared – force checked node sync
    setTimeout(() => {
      const treeViewObj = (this.dropDownTree as any).treeObj;

      if (treeViewObj) {
        const currentChecked = treeViewObj.getAllCheckedNodes(); // <== KEY FIX

        // Reassign checked nodes to force re-render
        treeViewObj.checkedNodes = [...currentChecked];
        treeViewObj.dataBind();
      }
    });
  }
}

private handlingNodeSelect = false;

onNodeSelect( event: any): void {
  // Writing `checkedNodes` raises `select` once per checked node, so a single
  // programmatic re-sync fired this handler once per selected organization.
  // Syncfusion flags those as not interacted; only a real click is ours to handle.
  if (!event?.isInteracted) return;
  if (this.handlingNodeSelect) return;
  this.handlingNodeSelect = true;

  try {
    const nodeData = event.itemData;
    const treeViewObj = (this.dropDownTree as any).treeObj;

    if (!nodeData || !treeViewObj) return;

    // Sync selected location IDs with valid "tank" IDs
    const allChecked = treeViewObj.getAllCheckedNodes?.() ?? [];
    const selectedIdsFromWriteValue = (this._value ?? []).map(v => `org_${v.value}`);

    const finalCheckSet = new Set<string>([
      ...allChecked,
      ...this.selectedOrganizationIds,
      ...selectedIdsFromWriteValue,
    ]);

    // Only keep valid node IDs from the tree
    const validCheckedNodes = [...finalCheckSet].filter(id =>
      this.treeData.some(node => node.id === id)
    );

    const nodeId = nodeData.id;
    const isChecked = nodeData.isChecked === 'true';

    // Only keep 'loc_' nodes
    //this.selectedLocationIds = allChecked.filter(id => id.startsWith('loc_') && this.locationNodeIds.includes(id));
    //this.selectedLocationIds = validCheckedNodes.filter(id => id.startsWith('loc_') && this.locationNodeIds.includes(id));

    this.selectedOrganizationIds = validCheckedNodes.filter(id =>
      id.startsWith('org_') &&
      !this.disabledOrgIds.includes(Number(id.replace('org_', '')))
    );
    
     if (!isChecked) {
      this.selectedOrganizationIds = this.selectedOrganizationIds.filter(id => id !== nodeId);
     }
    this.selectedOrganizationIds = [...this.selectedOrganizationIds];

    this.onChange(this.getSelectedDropDownsFromIds(this.selectedOrganizationIds));
    this.onTouched();
    this._cdr.detectChanges();
    //this.updateDisplayText();
  } finally {
    this.handlingNodeSelect = false;
  }
}


onCustomClear(): void {
  const ddTree = this.dropDownTree;
  const treeObj = (ddTree as any)?.treeObj;
  if (!treeObj) return;

  // 1. Use built-in clear
  ddTree.clear(); 

  // 2. Ensure all internal states are cleared
  treeObj.clearCheckedNodes?.();
  treeObj.clearSelection?.();

  // 3. Reset model
  this.selectedOrganizationIds = [];
  this.onChange([]);

  // 4. Clear visual input
  const input: HTMLInputElement = this.locationTreeElementRef?.nativeElement.querySelector('input');
  if (input) input.value = '';

  // 5. Delay re-binding disabled nodes
  setTimeout(() => {
    this.restoreDisabledCheckedNodes(treeObj);
    ddTree.dataBind();
    this._cdr.detectChanges();
  }, 0);
}

// onClearing(e: any) {
//   const selectedIds: string[] = this.dropDownTree.value || [];

//   const hasReadonly = selectedIds.some(id => this.isReadonly(id));

//   if (hasReadonly) {
//     e.cancel = true;
//   }
// }

isReadonly(id: string): boolean {
  if (!id.startsWith('org_')) return false;
  const numericId = Number(id.replace('org_', ''));
  return this.disabledOrgIds.includes(numericId);
}

private restoreDisabledCheckedNodes(treeObj: any): void {
  if (!this.disabledOrgIds?.length) return;

  const disabledChecked = this.treeData
    .filter(node =>
      node.id.startsWith('org_') &&
      this.disabledOrgIds.includes(Number(node.id.replace('org_', '')))
    )
    .map(node => node.id);

  // Restore disabled selections
  treeObj.checkedNodes = disabledChecked;
  treeObj.value = disabledChecked;
  treeObj.selectedNodes = disabledChecked;
  treeObj.dataBind();

  this._cdr.detectChanges();
}

private extractNumericId(id: string): number | null {
  const match = id.match(/^org_(\d+)$/);
  return match ? Number(match[1]) : null;
}

private getCheckedEnabledLocationIds(treeViewObj: any): string[] {
  const allChecked = treeViewObj.getAllCheckedNodes?.() ?? [];

  return allChecked.filter(id => {
    const isTank = id.startsWith('org_');
    if (!isTank) return false;

    const numericId = Number(id.replace('org_', ''));
    return !this.disabledOrgIds.includes(numericId);
  });
}

}
